module.exports = __webpack_public_path__ + "static/media/whatsappBroadcast.96c7469e.svg";